<template>
    <div class="card">
      <div class="card-header pb-0 d-flex">
        <h6>Customer table</h6>
        <input
          type="text"
          v-model="searchQuery"
          placeholder="Search..."
          class="form-control mb-3 ms-auto"
          style="max-width: 250px; "
        />
      </div>
      <div class="card-body px-0 pt-0 pb-2">
        <div class="table-responsive p-0">
          <table class="table align-items-center mb-0">
            <thead>
              <tr>
                <th
                  class="text-uppercase text-secondary text-xxs font-weight-bolder">
                  Name
                </th>
                <th
                  class="text-uppercase text-secondary text-xxs font-weight-bolder ps-2">
                  Address
                </th>
                <th
                  class="text-center text-uppercase text-secondary text-xxs font-weight-bolder">
                  Remark
                </th>
                <th
                  class="text-center text-uppercase text-secondary text-xxs font-weight-bolder">
                  Status
                </th>
                <th
                  class="text-center text-uppercase text-secondary text-xxs font-weight-bolder">
                  Date Created
                </th>
                <th class="text-secondary"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(customer,index) in paginatedCustomer" :key="index">
                <td>
                  <div class="d-flex px-2 py-1">
                    <div class="d-flex flex-column justify-content-center">
                      <h6 class="mb-0 text-sm">{{ (currentPage-1)*10 + index +1 }}. {{ customer.name }}</h6>
                      <p class="text-xs text-secondary mb-0">
                        {{ customer.contact}}
                      </p>
                    </div>
                  </div>
                </td>
                <td>
                  <h6 class="text-xs font-weight-bold mb-0">{{ customer.company }}</h6>
                  <p class="text-xs text-secondary mb-0">{{ customer.address }}</p>
                </td>
                <td>
                  <p class="text-xs font-weight-bold mb-0">{{ customer.remark }}</p>
                  <p class="text-xs text-secondary mb-0">{{ customer.cust_info }}</p>
                </td>
                <td class="align-middle text-center text-sm">
                  <!-- {{ customer.status}} -->
                  <span v-if="customer.status == 'Open' || customer.status == 'Following' || customer.status == 'Success'" class="badge badge-sm bg-gradient-success text-xs">{{ customer.status}}</span>
                  <span v-else-if="customer.status == 'Failed'" class="badge badge-sm bg-gradient-danger text-xs">{{ customer.status}}</span>
                  <span v-else class="badge badge-sm bg-gradient-info text-xs">{{ customer.status}}</span>
                </td>
                <td class="align-middle text-center">
                  <span class="text-secondary text-xs font-weight-bold" >
                    {{ customer.created_at }}
                    </span>
                </td>
                <td class="align-middle">
                  <RouterLink :to="{path : '/EditCustomer/'+ customer.customerid}"
                    href="javascript:;"
                    class="text-secondary font-weight-bold text-xs"
                    data-toggle="tooltip"
                    data-original-title="Edit user"
                    >Edit
                  </RouterLink>
                </td>
              </tr>
            </tbody>
          </table>
          <!-- Pagination Controls -->
          <hr />
          <div class="pagination-container">
            <div>
              <button @click="prevPage" :disabled="currentPage === 1" class="btn btn-info">Previous</button>
              <span class="form-control-label" style="padding:10px"> Page {{ currentPage }} of {{ totalPages }} </span>
              <button @click="nextPage" :disabled="currentPage === totalPages" class="btn btn-info">Next</button>
            </div>
            
            <span class="form-control-label total-rows">Total {{ totalRows }} entries </span>
          </div>
        </div>
      </div>
    </div>
  </template>
  
<script>
import axios from 'axios';

export default {
  name:'customerSelect',
  data(){
    return {
      totalRows: 0,
      currentPage: 0,
      perPage: 10,
      searchQuery:'',
      customers: []
    }
  },
  mounted(){
    this.getCustomerList();
  },
  computed: {
    totalPages() {
      return Math.ceil(this.customers.length / this.perPage);
    },
    paginatedCustomer() {
      const start = (this.currentPage - 1) * this.perPage;
      let query = this.searchQuery.toLowerCase();

      // Filter customers by checking all properties in each row
      let filtered = this.customers.filter(customer => {
        return Object.values(customer).some(value =>
          String(value).toLowerCase().includes(query)
        );
      });
      return filtered.slice(start, start + this.perPage);
    }
  },
  methods: {

    getCustomerList(){
        // console.log(localStorage.getItem('token'));
        // var mythis = this;
        axios.get('customer/listAllDetails')
            .then(res => {
              // console.log(res.data.customer);
                this.customers = res.data.customer;
                this.totalRows = res.data.customer.length;
                this.currentPage = 1;
            }).catch(function (error){
                if(error.response){
                    if(error.response.status == 422){
                        alert('Error: Name, Company, Contact, State and Address is required! ');
                    }
                }else if(error.request){
                    console.log(error.request);
                }else{
                    console.log('Error',error.message);
                }
            });
    }
  },
}
</script>